






import RemarkGroups from '../components/RemarkGroup/index.vue';
import Vue from 'vue';
export default Vue.extend({
  components: {
    RemarkGroups,
  },
});
